import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import FactorNameServices from "./TipoCriticidad.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getTipoCriticidad = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_TIPO_CRITICIDAD,
      payload: true,
    });
    const resp = await FactorNameServices.getTipoCriticidad(filters);
    dispatch({
      type: actions.GET_TIPO_CRITICIDAD,
      payload: resp.data,
    });
    dispatch({
      type: actions.TIPO_CRITICIDAD_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.TIPO_CRITICIDAD_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TIPO_CRITICIDAD,
      payload: false,
    });
  }
};

export const saveTipoCriticidad =
  (req, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_TIPO_CRITICIDAD,
        payload: true,
      });
      const resp = await FactorNameServices.saveTipoCriticidad(req);
      const { tipoCriticidad } = getState().tipoCriticidad;
      const _tipoCriticidad = tipoCriticidad
      _tipoCriticidad.data = [...tipoCriticidad.data, resp.data]
      dispatch({
        type: actions.GET_TIPO_CRITICIDAD,
        payload: _tipoCriticidad
    
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_TIPO_CRITICIDAD,
        payload: false,
      });
    }
  };

export const editTipoCriticidad =
  (req, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_TIPO_CRITICIDAD,
        payload: true,
      });
      const resp = await FactorNameServices.editTipoCriticidad(id, req);
      const { tipoCriticidad } = getState().tipoCriticidad;
      const _tipoCriticidad = tipoCriticidad
      _tipoCriticidad.data[index] = resp.data;
      dispatch({
        type: actions.GET_TIPO_CRITICIDAD,
        payload: _tipoCriticidad
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_TIPO_CRITICIDAD,
        payload: false,
      });
    }
  };

export const deleteTipoCriticidad =
  (id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_TIPO_CRITICIDAD,
        payload: true,
      });
      await FactorNameServices.deleteTipoCriticidad(id);
      const { tipoCriticidad } = getState().tipoCriticidad;
      const _tipoCriticidad = tipoCriticidad
      _tipoCriticidad.data.splice(index, 1);
      dispatch({
        type: actions.GET_TIPO_CRITICIDAD,
        payload: _tipoCriticidad
      });
      dispatch({
        type: actions.TIPO_CRITICIDAD_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data[0]) {
                message = ex.response.data[0];
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      toastr.error(message, "", {
        progressBar: true,
        rtl: true,
      });
    } finally {
      dispatch({
        type: actions.LOADING_TIPO_CRITICIDAD,
        payload: false,
      });
    }
  };
